import { ContentWrapper } from './Content.styled';
import { ContentProps } from './Content.types';

function Content({ children }: ContentProps) {
  return <ContentWrapper>{children}</ContentWrapper>;
}
export default Content;
